import { render, staticRenderFns } from "./EducationSkeleton.vue?vue&type=template&id=03112bd8&scoped=true&"
import script from "./EducationSkeleton.vue?vue&type=script&lang=js&"
export * from "./EducationSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./EducationSkeleton.vue?vue&type=style&index=0&id=03112bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03112bd8",
  null
  
)

export default component.exports